import {LucideIcon} from '@tryghost/shade/utils';

export const adminNavigationItems = [
    {to: '/superadmin', label: 'Overview', icon: LucideIcon.Activity},
    {to: '/superadmin/account-deletions', label: 'Account deletions', icon: LucideIcon.UsersRound},
    {to: '/superadmin/users', label: 'Users', icon: LucideIcon.UsersRound},
    {to: '/superadmin/sites', label: 'Publications', icon: LucideIcon.Newspaper},
    {to: '/superadmin/plans', label: 'Plans', icon: LucideIcon.Crown},
    {to: '/superadmin/marketplace', label: 'Marketplace', icon: LucideIcon.LayoutTemplate}
];
